import { keyframes } from "styled-components"

export const dropdown = keyframes`
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
`
export const dash = keyframes`
	from {
		stroke-dashoffset: 2000;
	}
	to {
		stroke-dashoffset: 0;
	}
`
